import type { OrderRow } from '../CsvExport.types'

export const sortOrderRowsByKey = <T extends keyof OrderRow>(
  orderRows: OrderRow[],
  field: T,
  direction: 'asc' | 'desc' = 'desc',
): OrderRow[] => {
  return [...orderRows].sort((a, b) => {
    const valueA = a[field] ?? ''
    const valueB = b[field] ?? ''
    const comparison = valueA > valueB ? 1 : -1

    return direction === 'desc' ? -comparison : comparison
  })
}
